import { Tabs } from "flowbite-react";
import "./index.scss";
import { FaCircleUser } from "react-icons/fa6";
import { renterTheme } from "../../../../renters/components/renter-dashboard/TabsStyle";
import { useCommissionReportsDashboardContext } from "./Commission.context";
import "../table-commission/Commission.scss";
import Total from "../table-commission/Total";
import Activation from "../table-commission/Activation.block";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getAllEmployees } from "@/common/services/employee.api";
import { IEmployee, TYPE_EMPLOYEE } from "@/types/employee.type";
import Preparation from "../table-commission/preparation.block";

export function CommissionReportsDashboard() {
  const { commission } = useCommissionReportsDashboardContext();
  const [, setActiveTab] = useState<number>(0);
  const { technicalConsultant } = useParams<{ technicalConsultant: string }>();
  const [consultantData, setConsultantData] = useState<IEmployee | null>(null);
  const [actualize, setActualize] = useState<boolean>(false);
  useEffect(() => {
    if (technicalConsultant) {
      const getConsultationData = async () => {
        const result = await getAllEmployees(technicalConsultant);
        setConsultantData(result.data[0]);
      };

      getConsultationData();
    }
  }, [technicalConsultant, actualize]);

  if (!commission) {
    return <div>Loading...</div>;
  }

  return (
    <div className="relative flex justify-center w-full h-full overflow-y-auto bg-white dark:bg-white dark:text-black">
      {consultantData &&
      !consultantData.type.includes(TYPE_EMPLOYEE.PREPARER) ? (
        <section className="commission-section">
          <Tabs
            className="tabs-style-commission"
            theme={renterTheme}
            aria-label="Default tabs"
            onActiveTabChange={(tabIndex) => setActiveTab(tabIndex)}
          >
            <Tabs.Item
              icon={FaCircleUser}
              title={<div className="tabs-name-style">Total</div>}
            >
              <Total
                commission={commission}
                actualize={actualize}
                setActualize={setActualize}
              />
            </Tabs.Item>
            <Tabs.Item
              icon={FaCircleUser}
              title={<div className="tabs-name-style">Ativações</div>}
            >
              <Activation commission={commission} />
            </Tabs.Item>
          </Tabs>
        </section>
      ) : (
        <section className="preparador-section w-full p-4">
          <Tabs
            className="tabs-style-commission"
            theme={renterTheme}
            aria-label="Default tabs"
            onActiveTabChange={(tabIndex) => setActiveTab(tabIndex)}
          >
            <Tabs.Item
              icon={FaCircleUser}
              title={<div className="tabs-name-style">Ordens de serviço</div>}
            >
              {consultantData && <Preparation consultant={consultantData} />}
            </Tabs.Item>
          </Tabs>
        </section>
      )}
    </div>
  );
}
